export class InvestmentConst {
  public static headerTable = [
    { field: 'provider', title: 'Proveedor', cell: (row) => `${row.provider}`, class: (row) => `` },
    { field: 'elementDescription', title: 'Descripción', cell: (row) => row.elementDescription ? `${row.elementDescription}` : '', class: (row) => `` },
    { field: 'accountActivity', title: 'Cuenta', cell:  (row) => row.accountActivity ? `${row.accountActivity}` : '', class: (row) => `` },
    { field: 'dateBuy', title: 'Fecha compra', cell:  (row) => row.dateBuy ? `${new Date(row.dateBuy).toLocaleDateString()}` : '', class: (row) => `` },
    { field: 'totalWithoutTax', title: 'Total sin impuestos', cell:  (row) => row.totalWithoutTax ? `${row.totalWithoutTax}` : '', class: (row) => `` },
    { field: 'totalTax', title: 'Total impuestos', cell:  (row) => row.totalTax ? `${row.totalTax}` : '', class: (row) => `` },
    { field: 'total', title: 'Total', cell:  (row) => row.total ? `${row.total}` : '', class: (row) => row.paided ? 'paid' : 'notPaid'},
    {
      field: 'paid', title: 'Pagado',
      cell: (row) => {
        if (row.paymentDate !== '') {
          return row.paymentDate;
        } else {
          return row.paid;
        }
      },
      class: (row) => ''
    },
  ];
}

export class AmortisationConst {
  public static amortisationTable = [
    { field: 'dateBuy', title: 'Fecha de compra', cell: (row) => row.dateBuy ? `${new Date(row.dateBuy).toLocaleDateString()}` : '', class: (row) => `` },
    { field: 'elementDescription', title: 'Elemento', cell: (row) => row.elementDescription ? `${row.elementDescription}` : '', class: (row) => `` },
    { field: 'totalWithoutTax', title: 'Precio compra', cell: (row) => `${row.totalWithoutTax} `, class: (row) => `` },
    { field: 'maximumPeriod', title: 'Años', cell: (row) => `${row.maximumPeriod}`, class: (row) => `` }
  ];
}

export class TableAmortisation {
  public static amortisationCalculateTable = [
    { field: 'name', title: 'Nombre elemento', cell: (row) => row.name, class: (row) => `` },
    { field: 'accountActivity', title: 'Cuenta', cell: (row) => row.accountActivity, class: (row) => `` },
    { field: 'year', title: 'Año', cell: (row) => `${row.year}`, class: (row) => `` },
    { field: 'moth', title: 'Mes', cell: (row) => `${row.month}`, class: (row) => `` },
    { field: 'amount', title: 'Cantidad', cell: (row) => `${row.amount}`, class: (row) => `` }
  ];
}
